import { render, staticRenderFns } from "./home-ljjk.vue?vue&type=template&id=c9e23280&scoped=true&"
import script from "./home-ljjk.vue?vue&type=script&lang=js&"
export * from "./home-ljjk.vue?vue&type=script&lang=js&"
import style0 from "./home-ljjk.vue?vue&type=style&index=0&id=c9e23280&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e23280",
  null
  
)

export default component.exports